import { APPOINTMENT_SERVICE_OPTIONS } from "./constants";

export function formatDuration(seconds) {
  if (seconds == null || Number.isNaN(Number(seconds))) {
    return "--";
  }

  const rounded = Math.round(Number(seconds));

  if (rounded < 60) {
    return `${rounded}s`;
  }

  const minutes = Math.floor(rounded / 60);
  const remainder = rounded % 60;

  return remainder ? `${minutes}m ${remainder}s` : `${minutes}m`;
}

export function formatPhone(phone) {
  if (!phone) {
    return "--";
  }

  const clean = String(phone).replace(/\s/g, "");

  if (!clean || clean === "unknown") {
    return "--";
  }

  return clean;
}

export function formatDateTime(value) {
  if (!value) {
    return "--";
  }

  try {
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return "--";
    }

    return date.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch (error) {
    return "--";
  }
}

export function formatNow() {
  return new Date().toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}

export function formatToday() {
  return new Date().toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function formatAppointmentService(serviceType) {
  const normalized = String(serviceType || "clinic").toLowerCase().trim();
  const option = APPOINTMENT_SERVICE_OPTIONS.find(
    ([value]) => value === normalized,
  );

  if (option) {
    return option[1];
  }

  if (!normalized) {
    return "Clinic Appointment";
  }

  return normalized
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function parseSlotHour(slot) {
  const match = String(slot || "").match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) {
    return Number.NaN;
  }

  let hour = Number(match[1]);
  const suffix = (match[3] || "").toUpperCase();

  if (suffix === "PM" && hour < 12) {
    hour += 12;
  }

  if (suffix === "AM" && hour === 12) {
    hour = 0;
  }

  return hour;
}

export function formatSlotTime(slot) {
  const text = String(slot || "").trim();

  if (!text) {
    return "--";
  }

  if (/\b(?:AM|PM)\b/i.test(text)) {
    return text.toUpperCase().replace(/\s+/g, " ");
  }

  const match = text.match(/(\d{1,2}):(\d{2})/);

  if (!match) {
    return text;
  }

  let hour = Number(match[1]);
  const minute = match[2];
  const suffix = hour < 12 ? "AM" : "PM";

  if (hour === 0) {
    hour = 12;
  } else if (hour > 12) {
    hour -= 12;
  }

  return `${hour}:${minute} ${suffix}`;
}

export function parseAppointmentDateTime(dateText, timeText) {
  const day = String(dateText || "").trim();

  if (!day) {
    return null;
  }

  const value = String(timeText || "").trim();

  if (!value) {
    return `${day}T12:00:00+04:00`;
  }

  const compact = value.toUpperCase().replace(/\s+/g, " ").trim();
  const match = compact.match(/^(\d{1,2})(?::(\d{2}))?\s*(AM|PM)?$/i);

  if (match) {
    let hour = Number(match[1] || 0);
    const minute = String(match[2] || "00").padStart(2, "0");
    const meridiem = (match[3] || "").toUpperCase();

    if (meridiem === "PM" && hour < 12) {
      hour += 12;
    }

    if (meridiem === "AM" && hour === 12) {
      hour = 0;
    }

    return `${day}T${String(hour).padStart(2, "0")}:${minute}:00+04:00`;
  }

  if (/^\d{1,2}:\d{2}$/.test(compact)) {
    const [hour, minute] = compact.split(":");
    return `${day}T${hour.padStart(2, "0")}:${minute}:00+04:00`;
  }

  return `${day}T12:00:00+04:00`;
}

export function shiftIsoDate(dateText, deltaDays) {
  const base = new Date(`${String(dateText).slice(0, 10)}T00:00:00Z`);

  if (Number.isNaN(base.getTime())) {
    return String(dateText).slice(0, 10);
  }

  base.setUTCDate(base.getUTCDate() + deltaDays);

  return base.toISOString().slice(0, 10);
}
